import { shouldPerformTransition, performTransition } from 'turbo-view-transitions';

document.addEventListener('turbo:before-render', (e) => {
  if (shouldPerformTransition()) {
    e.preventDefault();

    performTransition(document.body, event.detail.newBody, async () => {
      await e.detail.resume();
    });
  }
});

document.addEventListener('turbo:load', () => {
  // View Transitions don't play nicely with Turbo cache
  if (shouldPerformTransition()) Turbo.cache.exemptPageFromCache();
});
